export default "__VITE_ASSET__ltSUDU$v__"